/**
 * Bootstrap and Slick carousel widgets.
 * @author: BenJ
 */
$(document).ready(function() {

    // Slick carousel
    if ($.fn.slick) {
        // Slick slideshow
        $('.slide-slideshow').each(function(){
            var $self = $(this);
            var options = {
                dots: $self.data('dots') || false,
                arrows: $self.data('arrows') || false,
                infinite: true,
                speed: 500,
                autoplay: false,
                autoplaySpeed: 4000,
                fade: true,
                mobileFirst: true,
                useTransform: true,
                cssEase: 'linear',
                responsive: []
            };

            if ($self.parents('.widget').hasClass('carousel-lg-default')) {
                options.responsive.push({
                    breakpoint: 768,
                    settings: "unslick"
                })
            }

            let slider = $self.slick(options);
            $self.slickLightbox({
                src: 'data-remote',
                itemSelector: 'img',
            });

            $self.on('inview', function() {
                slider.slick('slickPlay').slick('slickSetOption', 'autoplay', true);
            })
        });
    }
});
